import { getNumbersBetween } from '@core/utils/number';

import { HealthHistoryQuestionOption } from './question';

export const heightOptions: HealthHistoryQuestionOption[] = getNumbersBetween(48, 84).map((inches) => ({
  label: 'Health_History.Height.Feet_And_Inches',
  labelValue1: Math.floor(inches / 12),
  labelValue2: inches % 12,
  value: inches
}));
